var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-bubble user",style:({
    background: _vm.widgetColor,
    color: _vm.widgetColor === _vm.HIVER_COLOR ? 'black' : 'white',
  }),domProps:{"innerHTML":_vm._s(_vm.textHTML(_vm.message, _vm.readableTime))}})}
var staticRenderFns = []

export { render, staticRenderFns }